<template>
    <div class="advanced-search layout-sub-page">
        <!-- 1. 搜索tab -->
        <div class="title-bar search-title-bar dsp-flex">
            <div class="title-side title-left">
                <i class="iconfont icon-xiangzuo" @click="clickBack"></i>
            </div>
            <div class="title-middle">
                <div class="title-tab-item" @click="toggleTab('ganzhi')" v-bind:class="{'tab-cur': advancedType == 'ganzhi'}"><span>干支搜索</span></div>
                <div class="title-tab-item" @click="toggleTab('wuxing')" v-bind:class="{'tab-cur': advancedType == 'wuxing'}"><span>五行搜索</span></div>
            </div>
            <div class="title-side title-right" @click="clickClear">清空</div>
        </div>

        <div class="advanced-search-main">
            <!-- 2. 搜索控件 -->
            <advanced-search-box></advanced-search-box>

            <!-- 3. 搜索结果列表 -->
            <advanced-search-list></advanced-search-list>
        </div>        

        <!-- 4. 选择框 -->
        <choose-item-pop :showPop='showChooseItemPop' :itemList='searchChooseItemList' :cancelFunc='clickChooseItemPopOverLay' :itemFunc='clickChooseItem'></choose-item-pop>
    </div>
</template>


<script>
import AdvancedSearchBox from "../../layouts/search/AdvancedSearchBox.vue";
import AdvancedSearchList from "../../layouts/search/AdvancedSearchList.vue";
import ChooseItemPop from "../../components/ChooseItemPop.vue";
import { MIX } from '../../modules/utils';
export default {
    name: 'AdvancedSearch',
    components: { AdvancedSearchBox, AdvancedSearchList, ChooseItemPop },
    data() {
        return {
            
        }
    },
    computed: {
        advancedType() {
            return this.$store.state.search.advancedType;
        },
        showChooseItemPop() {
            return this.$store.state.search.showChooseItemPop;
        },
        searchChooseItemList() {
            return this.$store.state.search.searchChooseItemList;
        }
    },
    mounted: function() {
        setTimeout(() => {
            this.initDom();
            MIX.trackPageViewed('GanZhiWuXingSearch');
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style = 'width: '+ window.innerWidth + 'px; height: ' + window.innerHeight + 'px';
            this.$el.style.overflow = 'hidden';
            // 设置顶部的高度
            var topDiv = document.getElementsByClassName('search-title-bar')[0];
            var mainDiv = document.getElementsByClassName('advanced-search-main')[0];
            mainDiv.style = 'padding-top: ' + topDiv.clientHeight + 'px';

            if(this.$store.state.search.advancedType == ''){
                this.$store.state.search.advancedType = 'ganzhi';
            }
        },
        clickBack() {
            this.$store.dispatch('search/resetData');

            let curUrl = this.$router.history.current.fullPath;
                curUrl = curUrl.replace('/advanced', '');
            this.$router.replace(curUrl);
        },
        clickClear() {
            this.$store.dispatch('search/resetData');
            this.$bus.emit('resetItemComponent');
        },
        clickChooseItemPopOverLay() {
            this.$store.state.search.showChooseItemPop = false;
        },
        clickChooseItem(data) {
            this.$store.state.search.showChooseItemPop = false;
            this.$store.dispatch('search/chooseSearchChooseData', data);
        },
        toggleTab(type){
            this.$store.dispatch('search/resetData');
            this.$store.state.search.advancedType = type;
        }
    }
}
</script>